export enum AddressChangerPuppeteerStatus {
  Opened = 'opened',
  Closed = 'closed',
  Idle = 'idle',
  Error = 'error',
}

export enum AddressChangerSocketEventNames {
  PuppeteerHealth = 'puppeteerHealth',
  UpdateChangingStatus = 'updateChangingStatus',
}
